import { PageNotFound } from '@/app/components';

export function NotFoundPage() {
  return (
    <div id="error-page">
      <PageNotFound />
    </div>
  );
}
